import AutoNumeric from "autonumeric";
import {initCurrencyInput} from "./autonumeric";
import {initFormTab} from "./form_tab";

function refreshChildrenFields(event, extraParam = {}) {
    const udpId = $('#journal_entry_udp_id').val();
    const docTypeSelect = $('#journal_entry_document_type_id');
    const docTypeId = docTypeSelect.val();

    // Prende l'`identifier` dal data-attribute dell'opzione selezionata
    const selectedOption = docTypeSelect.find('option:selected');
    const identifier = selectedOption.data('identifier');
    const form = docTypeSelect.closest('form');
    const journalEntryID = form.data("journal-entry-id");
    let data = {
        udp_id: udpId,
        document_type_id: docTypeSelect.val(),
        journalEntryID: journalEntryID
    };

    // con questa condizione non vi svuota in caso di mancanza di document_type
    //if (identifier !== 'chiusura_cassa') return; // esegue solo se è "chiusura_cassa"

    $.ajax({
        url: '/admin/journal_entries/refresh_children_chiusura',
        method: 'GET',
        data: data,
        success: function (html) {
            const $container = $('#children_chiusura_container');

            // NEW content
            const ht = $(html).find('.content-to-clone');
            ht.find('.has-many-container[data-has-many-association="children_chiusura"]').remove()

            // marko per il destroy e muovo fuori per non cancellarlo
            let destroyInput = $container.find('input[id$=__destroy]');
            if (destroyInput.length > 0) {
                // destroyInput.attr('checked','checked');
                destroyInput.val('1')
            }
            const $elToHide = $container.find('> ol > fieldset')
            $elToHide.hide()
            $container.before($elToHide)


            $container.find('> ol').html(ht);
            ht.find('input.currency').each(function (i, el) {
                initCurrencyInput(el)
            })

            initCheckChiusura($container);
            initFormTab()
        },
        error: function () {
            console.error('Errore nel caricamento dei children_chiusura');
        }
    });
}

function initCheckChiusura($c=null) {
    let $container = $c ? $c : $('#children_chiusura_container');
    let $form = $container.closest('form.journal_entry')
    const chiusura = $form.find('#journal_entry_amount');
    const amounts = $container.find("input[id$=_amount]")
    $.each($.merge( [chiusura], amounts ), function (i, el) {
        $(el).off('change.check-chiusura-cassa keyup.check-chiusura-cassa paste.check-chiusura-cassa')
        $(el).on('change.check-chiusura-cassa keyup.check-chiusura-cassa paste.check-chiusura-cassa', function (e) {
            const data = $form.serialize();
            const chiusuraInstance = AutoNumeric.getAutoNumericElement(chiusura.get(0));
            const chiusuraVal = chiusuraInstance.getNumber()
            let totalChild = 0
            $.each(amounts, function (i, el) {
                const amountInstance = AutoNumeric.getAutoNumericElement(el);
                totalChild += amountInstance.getNumber()
            })
            if (totalChild !== chiusuraVal) {
                if ($('.my-chiusura-error').length === 0) {
                    $form.prepend("<ul class=\"errors my-chiusura-error\"><li>Cifra non corrisponde all'importo chiusura</li><li>Importo chiusura non corrisponde alla somma dei valori sotto</li></ul>")
                }
            } else {
                $('.my-chiusura-error').remove()
            }
        })
    })
}

function initRefreshDocumentLocation() {
    const udpSelect = $('#journal_entry_udp_id');
    const documentTypeSelect = $('#journal_entry_document_type_id');
    const $container = $('#children_chiusura_container');
    const eventName = 'change.refresh-child'
    udpSelect.on(eventName, refreshChildrenFields);
    documentTypeSelect.on(eventName, refreshChildrenFields);
    udpSelect.closest('form').find('.has-many-container[data-has-many-association="children_chiusura"]').hide()
    $container.find('> ol > fieldset').length == 0 && udpSelect.val() && $('#journal_entry_document_type_id').trigger(eventName) // refresh nel caso di current_udp present in new_chiusura
    // $('#journal_entry_document_type_id').trigger(eventName) // non posso triggerare altrimenti con errori di validazione resetta i valori
}

function initChiusuraCassa() {

    // visualizza il blocco annulli totale ecc
    const container = $('form.journal_entry fieldset.inputs.chiusura_cassa');
    const annulli = $('form.journal_entry fieldset.inputs.chiusura_cassa #journal_entry_import_annulli');
    const totale = $('form.journal_entry fieldset.inputs.chiusura_cassa #journal_entry_import_totale');
    const chiusura = $('form.journal_entry fieldset.inputs.chiusura_cassa #journal_entry_amount');
    if (container.length > 0) {
        // CALCOLO ANNULLI - TOTALE
        $.each([annulli, totale], function (i, el) {
            $(el).off('change.sync-chiusura-cassa keyup.sync-chiusura-cass paste.sync-chiusura-cass')
            $(el).on('change.sync-chiusura-cassa keyup.sync-chiusura-cass paste.sync-chiusura-cass', function () {
                const annulliInstance = AutoNumeric.getAutoNumericElement(annulli.get(0));
                const totaleInstance = AutoNumeric.getAutoNumericElement(totale.get(0));
                const chiusuraInstance = AutoNumeric.getAutoNumericElement(chiusura.get(0));
                const annulliValString = annulliInstance.getNumericString()
                const totalValString = totaleInstance.getNumericString()
                const annulliVal = annulliInstance.getNumber()
                const totalVal = totaleInstance.getNumber()
                if (annulliValString && totalValString) {
                    chiusuraInstance.set(totalVal - annulliVal)
                }
            })
        })
    }
}

export {initChiusuraCassa, initRefreshDocumentLocation, initCheckChiusura}